// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SHOW_AVAILABILITY_OVERLAY = 'uiState/availability/SHOW_OVERLAY';
export const HIDE_AVAILABILITY_OVERLAY = 'uiState/availability/HIDE_OVERLAY';

export const showOverlay = (): PureAction => {
  return {
    type: PURE(SHOW_AVAILABILITY_OVERLAY),
  };
};

export const hideOverlay = (): PureAction => {
  return {
    type: PURE(HIDE_AVAILABILITY_OVERLAY),
  };
};
